import React from 'react';
import * as styles from './styles.module.scss';

interface Props {
  discount: number;
}

export const DiscountPercentage: React.FC<Props> = ({ discount }) => (
  <div className={styles.container}>
    {Math.round(discount)}% Off
  </div>
);
